import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IdentificationStepsService } from '../../services/identification-steps.service';
import { DeliveryStepsService } from '../../services/delivery-steps.service';

@Component({
    selector: 'payment-identification-identified-user',
    templateUrl: './payment.identification.identified-user.component.html',
    styleUrls: ['../../payment.component.scss']

})
export class PaymentIdentificationIdentifiedUserComponent {
    @Output() reseted: EventEmitter<null> = new EventEmitter();
    @Input() name1: string;
    @Input() email: string;

    constructor(
        protected identificationStepsService: IdentificationStepsService,
        protected deliveryStepsService: DeliveryStepsService
    ) {}

    /**
     * Reset identified user.
     * */
    public reset(): void {
        this.reseted.emit();
        this.identificationStepsService.resetEmail();
        this.identificationStepsService.resetUser();
        this.deliveryStepsService.reset();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/payment/identification/identified-user/payment.identification.identified-user.component.ts